import { render, staticRenderFns } from "./HabitFailed.vue?vue&type=template&id=b59e75a0"
import script from "./HabitFailed.vue?vue&type=script&lang=js"
export * from "./HabitFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports